import { useCallback, useEffect, useState } from 'react'

function useSentry() {
  const [sentryAvailable, setSentryAvailable] = useState(false)

  useEffect(() => {
    function checkSentryAvailability() {
      if (window.Sentry && typeof window.Sentry.captureException === 'function') {
        setSentryAvailable(true)
      }
    }

    // Check if Sentry is already available
    checkSentryAvailability()

    // Set up an interval to check periodically until Sentry is loaded
    const intervalId = setInterval(() => {
      if (!sentryAvailable) {
        checkSentryAvailability()
      } else {
        clearInterval(intervalId)
      }
    }, 100)

    // Clean up interval on unmount
    return () => {
      clearInterval(intervalId)
    }
  }, [sentryAvailable])

  const captureException = useCallback((error, options = {}) => {
    if (sentryAvailable && window.Sentry) {
      return window.Sentry.captureException(error, options)
    }
    // No-op when Sentry is not available
    return null
  }, [sentryAvailable])

  return {
    captureException,
  }
}

export default useSentry
